import React from "react";
import { Facebook, Instagram, Pinterest } from "../../customIcons";
import style from "./SocialIconsList.module.css";

export const SocialIconsList = ({ fill }) => {
  return (
    <ul className={style.socialIconsList}>
      <li>
        <a
          href="https://www.instagram.com/homecraft_masters/"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
        >
          <Instagram fill={fill} />
        </a>
      </li>
      <li>
        <a
          href="https://ru.pinterest.com/"
          target="_blank"
          rel="noreferrer"
          aria-label="Pinterest"
        >
          <Pinterest fill={fill} />
        </a>
      </li>
      <li>
        <a
          href="https://www.facebook.com/"
          target="_blank"
          rel="noreferrer"
          aria-label="Facebook"
        >
          <Facebook fill={fill} />
        </a>
      </li>
    </ul>
  );
};
